<template>
  <div>
    <div class="page-header">
      <div>
        <div class="page-title">财务管理</div>
        <div class="page-subtitle">结算、对账与资金监控</div>
      </div>
      <el-button type="primary" @click="openPayDialog">发起代付</el-button>
    </div>
    <el-row :gutter="16" class="stats-row">
      <el-col :span="8">
        <el-card>
          <div class="stat">
            <div class="stat-label">可结算余额</div>
            <div class="stat-value">￥328,900</div>
            <div class="stat-meta">今日结算 12 笔</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div class="stat">
            <div class="stat-label">已代付总额</div>
            <div class="stat-value">¥5000</div>
            <div class="stat-meta">成功付款 10 笔</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div class="stat">
            <div class="stat-label">渠道结算中</div>
            <div class="stat-value">¥10000</div>
            <div class="stat-meta">待结算 10 笔</div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-card>
      <div class="stat-value">代付记录</div>
      <el-table :data="records" stripe>
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="admin_id" label="商户ID" width="100" />
        <el-table-column prop="amount" label="发起金额" width="140" />
        <el-table-column prop="payee_name" label="收款人姓名" width="140" />
        <el-table-column prop="payee_card_no" label="收款卡号" min-width="180" />
        <el-table-column prop="payee_bank" label="收款银行" width="140" />
        <el-table-column prop="status_text" label="付款状态" width="120" />
        <el-table-column prop="remark" label="备注" min-width="160" />
        <el-table-column prop="created_at" label="发起时间" width="170" />
        <el-table-column prop="paid_at" label="付款时间" width="170" />
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="openDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-pagination">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-size="pagination.limit"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>

    <el-dialog title="发起代付" :visible.sync="payDialogVisible" width="520px">
      <el-form label-width="110px">
        <el-form-item label="发起金额">
          <el-input v-model="payForm.amount" placeholder="请输入金额" />
        </el-form-item>
        <el-form-item label="收款人姓名">
          <el-input v-model="payForm.payee_name" placeholder="请输入收款人姓名" />
        </el-form-item>
        <el-form-item label="收款卡号">
          <el-input v-model="payForm.payee_card_no" placeholder="请输入收款卡号" />
        </el-form-item>
        <el-form-item label="收款银行">
          <el-input v-model="payForm.payee_bank" placeholder="请输入收款银行" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="payForm.remark" type="textarea" :rows="2" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="payDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPay">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="代付详情" :visible.sync="detailDialogVisible" width="520px">
      <el-form label-width="110px">
        <el-form-item label="ID">
          <el-input v-model="detail.id" disabled />
        </el-form-item>
        <el-form-item label="商户ID">
          <el-input v-model="detail.admin_id" disabled />
        </el-form-item>
        <el-form-item label="发起金额">
          <el-input v-model="detail.amount" disabled />
        </el-form-item>
        <el-form-item label="收款人姓名">
          <el-input v-model="detail.payee_name" disabled />
        </el-form-item>
        <el-form-item label="收款卡号">
          <el-input v-model="detail.payee_card_no" disabled />
        </el-form-item>
        <el-form-item label="收款银行">
          <el-input v-model="detail.payee_bank" disabled />
        </el-form-item>
        <el-form-item label="付款状态">
          <el-input v-model="detail.status_text" disabled />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="detail.remark" disabled />
        </el-form-item>
        <el-form-item label="发起时间">
          <el-input v-model="detail.created_at" disabled />
        </el-form-item>
        <el-form-item label="付款时间">
          <el-input v-model="detail.paid_at" disabled />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 维护本地状态，避免直接修改props
      localGoods: [],
      payDialogVisible: false,
      payForm: {
        amount: "",
        payee_name: "",
        payee_card_no: "",
        payee_bank: "",
        remark: ""
      },
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      records: [],
      detailDialogVisible: false,
      detail: {}
    };
  },
  computed: {},
  // 页面挂载完成
  mounted() { },
  // 页面创建完成
  created() {
    // 初始化拉取列表
    this.getRecords();
  },
  methods: {
    // 打开发起代付弹窗
    openPayDialog() {
      this.payForm.amount = "";
      this.payForm.payee_name = "";
      this.payForm.payee_card_no = "";
      this.payForm.payee_bank = "";
      this.payForm.remark = "";
      this.payDialogVisible = true;
    },
    // 提交代付
    submitPay() {
      if (!this.payForm.amount || !this.payForm.payee_name || !this.payForm.payee_card_no || !this.payForm.payee_bank) {
        this.$message.warning("请填写完整信息");
        return;
      }
      this.$message.warning("请对接代付接口");
      this.payDialogVisible = false;
    },
    // 获取代付记录
    getRecords() {
      const query = this.buildQuery({
        page: this.pagination.page,
        limit: this.pagination.limit
      });
      this.$http_get(`/admin/finance/list?${query}`, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          const list = Array.isArray(res.data.data) ? res.data.data : [];
          this.records = this.mapRecords(list);
          this.pagination.total = Number(res.data.total || 0);
          this.pagination.page = Number(res.data.current_page || this.pagination.page);
          this.pagination.limit = Number(res.data.per_page || this.pagination.limit);
        }
      });
    },
    // 拼接查询参数
    buildQuery(params) {
      return Object.keys(params)
        .filter(key => params[key] !== "" && params[key] !== null && params[key] !== undefined)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join("&");
    },
    // 映射记录字段
    mapRecords(list) {
      return list.map(item => ({
        ...item,
        status_text: this.getStatusText(item.status),
        created_at: this.formatTime(item.created_at),
        paid_at: this.formatTime(item.paid_at)
      }));
    },
    // 获取状态文案
    getStatusText(value) {
      if (value === "paid" || value === "已完成") {
        return "已完成";
      }
      if (value === "processing" || value === "处理中") {
        return "处理中";
      }
      if (value === "failed" || value === "失败") {
        return "失败";
      }
      return value || "";
    },
    // 格式化时间
    formatTime(value) {
      if (!value) {
        return "";
      }
      const numeric = Number(value);
      const dateValue = Number.isNaN(numeric) ? new Date(value) : new Date(numeric * 1000);
      if (Number.isNaN(dateValue.getTime())) {
        return String(value);
      }
      const year = dateValue.getFullYear();
      const month = String(dateValue.getMonth() + 1).padStart(2, "0");
      const day = String(dateValue.getDate()).padStart(2, "0");
      const hour = String(dateValue.getHours()).padStart(2, "0");
      const minute = String(dateValue.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}`;
    },
    // 打开详情
    openDetail(row) {
      this.$http_get(`/admin/finance/detail?id=${row.id}`, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          this.detail = {
            ...res.data,
            status_text: this.getStatusText(res.data.status),
            created_at: this.formatTime(res.data.created_at),
            paid_at: this.formatTime(res.data.paid_at)
          };
          this.detailDialogVisible = true;
        }
      });
    },
    // 切换页码
    handlePageChange(page) {
      this.pagination.page = page;
      this.getRecords();
    },
    // 切换每页条数
    handleSizeChange(size) {
      this.pagination.limit = size;
      this.pagination.page = 1;
      this.getRecords();
    }
  }
};
</script>

<style>
.table-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
